module.exports = __webpack_public_path__ + "static/media/Chart.3f207bd6.svg";